  function toggleFaq(item) {
    const wasOpen = item.classList.contains('open');
    item.parentElement.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  }
  (function() {
    const carousel = document.getElementById('brandsCarousel');
    const dotsWrap = document.getElementById('brandsDots');
    const dots = dotsWrap.querySelectorAll('.dot-btn');
    const slides = carousel.querySelectorAll('.brand-slide');
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index, 10);
        slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
    carousel.addEventListener('scroll', () => {
      const scrollLeft = carousel.scrollLeft;
      let closest = 0;
      let minDist = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      dots.forEach((d, i) => d.classList.toggle('active', i === closest));
    });
  })();
